// extracted by mini-css-extract-plugin
export default {"card":"d5-z"};